import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { VehiclesService } from "../vehicles/vehicles.service";

@Component({
  selector: "app-truck-tyres",
  templateUrl: "./truck-tyres.component.html",
  styleUrls: ["./truck-tyres.component.sass"],
})
export class TruckTyresComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private vehiclesService: VehiclesService
  ) {}

  selectedTyre: any = null;
  showTyreModal = false;
  allTyres: any[] = [];
  ngOnInit(): void {
    this.getAllTruckTyres();
  }

  getAllTruckTyres() {
    this.spinner.show();
    let data = {
      isActive: 1,
    };
    this.vehiclesService.getTyres(data).subscribe((result: any) => {
      if (result.statusCode == 200) {
        // console.log("get all vehicles ", result);
        this.allTyres = result.data;
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  deleteTyre(id) {
    this.spinner.show();
    this.vehiclesService.delete(id).subscribe((result: any) => {
      if (result.statusCode == 200) {
        this.toastr.success(result.message);
        this.getAllTruckTyres();
        this.spinner.hide();
      } else {
        this.spinner.hide();
        this.toastr.error(result.message);
      }
    });
  }

  openAddTyre() {
    this.selectedTyre = null;
    this.showTyreModal = true;
  }

  openEditTyre(tyre: any) {
    this.selectedTyre = { ...tyre };
    console.log("tyre", tyre);
    this.showTyreModal = true;
  }

  handleCloseModal() {
    this.showTyreModal = false;
  }
}
